import {
    UPDATE_PRODUCT_LOCALISATION,
    UPDATE_PRODUCT_LOCALISATION_FAILURE,
    UPDATE_PRODUCT_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const updateProductLocalisation = (payload) => {
    return {
        type: UPDATE_PRODUCT_LOCALISATION,
        payload: payload,
    };
};

export const updateProductLocalisationFailure = (error, payload) => {
    return {
        type: UPDATE_PRODUCT_LOCALISATION_FAILURE,
        error: error,
        payload: payload,
    };
};

export const updateProductLocalisationSuccess = (payload, response) => {
    return {
        type: UPDATE_PRODUCT_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/product-localisation/updateProductLocalisation.js